//                                                   
import { repo } from '@bi/sync';
export const MessagesRepository = repo.vcp.MessagesRepository;
